import { render } from "./ContainerFluid.vue?vue&type=template&id=370e3d61&scoped=true"
import script from "./ContainerFluid.vue?vue&type=script&lang=js"
export * from "./ContainerFluid.vue?vue&type=script&lang=js"

import "./ContainerFluid.vue?vue&type=style&index=0&id=370e3d61&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-370e3d61"]])

export default __exports__